/**
 * RequirePermission — gate a route on an RBAC permission. Renders `fallback`
 * (default: redirect to home) when the user lacks the permission.
 */
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { selectRoles } from '@security/auth/authSlice';
import { can } from '@security/permissions';

export function RequirePermission({ permission, fallback, children }) {
  const roles = useSelector(selectRoles);
  if (!can(roles, permission)) {
    return fallback ?? <Navigate to="/" replace />;
  }
  return children;
}
